// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"root_1Co3j","label":"label_FG4xv","value":"value_grfd3"};